import client from './client';
import type { HealthSummary, Site } from '@/types';

export async function getHealthSummary(): Promise<HealthSummary> {
  const { data } = await client.get<HealthSummary>('/health/summary');
  return data;
}

export async function getHealth(): Promise<{ status: string; database: string; uptimeChecker: string }> {
  const { data } = await client.get('/health');
  return data;
}

export async function getPublicSite(token: string): Promise<Partial<Site>> {
  const { data } = await client.get<Partial<Site>>(`/public/${token}`);
  return data;
}

export const healthApi = {
  getHealthSummary,
  getHealth,
  getPublicSite,
};

export default healthApi;
